import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, BriefcaseIcon, CodeIcon } from 'lucide-react';
const pillars = [{
  icon: TrendingUpIcon,
  title: 'Performance Marketing',
  description: 'Acquisition rentable via Meta Ads, Google Ads, et stratégies data-driven. Leads qualifiés, ROAS optimisé, croissance mesurable.',
  color: 'blue',
  accent: 'from-blue-500 to-blue-600'
}, {
  icon: BriefcaseIcon,
  title: 'Conseil Marketing & Business',
  description: 'Développement commercial, audit marketing, optimisation e-commerce. Stratégie actionnable pour scaler votre activité.',
  color: 'purple',
  accent: 'from-purple-500 to-purple-600'
}, {
  icon: CodeIcon,
  title: 'IT Consulting & Ingénierie',
  description: 'Plateformes sur mesure, cybersécurité, architecture cloud. Infrastructure stable, performante et sécurisée.',
  color: 'emerald',
  accent: 'from-emerald-500 to-emerald-600'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function ServicePillars() {
  return <section className="py-40 bg-white relative" data-id="element-99">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" data-id="element-100" />

      <div className="max-w-7xl mx-auto px-6" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-24" data-id="element-102">
          <h2 className="text-6xl md:text-7xl font-black text-black mb-6 tracking-tight" data-id="element-103">
            Les 3 Pôles Nexyom
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light" data-id="element-104">
            Une seule entité. Un seul interlocuteur. Tout ce qui bloque votre
            croissance.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-3 gap-6" data-id="element-105">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={index} variants={itemVariants} className="group relative bg-gray-50 p-12 transition-all duration-500 hover:bg-white hover:shadow-2xl" data-id="element-106">
                {/* Icon with gradient background */}
                <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${pillar.accent} mb-8 relative`} data-id="element-107">
                  <Icon className="w-10 h-10 text-white" strokeWidth={1.5} data-id="element-108" />
                </div>

                <h3 className="text-2xl font-bold text-black mb-5 tracking-tight" data-id="element-109">
                  {pillar.title}
                </h3>

                <p className="text-gray-600 leading-relaxed font-light" data-id="element-110">
                  {pillar.description}
                </p>

                {/* Hover border effect */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-black transition-all duration-500" data-id="element-111" />

                {/* Corner accent */}
                <div className={`absolute top-0 right-0 w-16 h-16 bg-gradient-to-br ${pillar.accent} opacity-0 group-hover:opacity-10 transition-opacity duration-500`} data-id="element-112" />
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}